import { render, staticRenderFns } from "./TemplatesControl.vue?vue&type=template&id=e6edefd4&scoped=true"
import script from "./TemplatesControl.vue?vue&type=script&lang=js"
export * from "./TemplatesControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6edefd4",
  null
  
)

export default component.exports